import React from 'react';
import { CheckCircle, Warning, XCircle, Clock } from '@phosphor-icons/react';

export const VERIFICATION_METHODS = [
  { value: 'GPS', label: 'GPS (Mobile App)' },
  { value: 'Telephony', label: 'Telephony (Phone)' },
  { value: 'FOB', label: 'FOB Device' },
  { value: 'Manual', label: 'Manual Entry' },
];

const STATUS_BADGE_STYLES = {
  Pending: 'bg-amber-50 text-amber-700 border-amber-200',
  Validated: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Exception: 'bg-red-50 text-red-700 border-red-200',
  Rejected: 'bg-red-50 text-red-700 border-red-200',
};

export const getStatusBadgeClass = (status) =>
  STATUS_BADGE_STYLES[status] || 'bg-slate-100 text-slate-700';

export const getStatusIcon = (status) => {
  switch (status) {
    case 'Validated':
      return <CheckCircle size={14} className="text-emerald-600" />;
    case 'Exception':
      return <Warning size={14} className="text-red-600" />;
    case 'Rejected':
      return <XCircle size={14} className="text-red-600" />;
    default:
      return <Clock size={14} className="text-amber-600" />;
  }
};

export const DEFAULT_VISIT_FORM = {
  employee_id: '',
  patient_id: '',
  service_date: new Date().toISOString().split('T')[0],
  time_in: '09:00',
  time_out: '11:00',
  service_code: '',
  payer_type: '',
  payer_program: '',
  verification_method: 'GPS',
  clock_in_latitude: '',
  clock_in_longitude: '',
  clock_out_latitude: '',
  clock_out_longitude: '',
  tasks_performed: [],
  notes: '',
};
